/**
 * The value of `?looks=` that asks for the composed crowd.
 */
export const CROWD_LOOKS = "crowd";

/**
 * Whether the page draws every creature as a composed look (P2.10-T5, ADR-094 decision 17): only when `?looks=crowd`
 * asks for it and the page is a development page (`isDevelopmentPage`, `endpoint.ts`; P1.9-T143), as the benchmark
 * mode is gated (`bench-gate.ts`). It is a developer's measuring flag: each creature wears a look derived from its
 * handle, so the stress world's crowd rows stand in for a crowd of players with nothing on the wire. A published page
 * ignores `?looks=`: its players are composed looks and its creatures are drawn from their own sheets. The world the
 * page plays has no say, since a world id comes from the page's address.
 *
 * @param looks The page's `?looks=` value, or null when it has none.
 * @param development Whether the page is a development page.
 * @returns True when creatures are drawn as composed looks.
 * @example
 * crowdLooksAllowed("crowd", isDevelopmentPage("play.odysseytales.net", "")); // false
 * crowdLooksAllowed("crowd", isDevelopmentPage("192.168.10.110:3000", "")); // true
 */
export function crowdLooksAllowed(looks: string | null, development: boolean): boolean {
  return looks === CROWD_LOOKS && development;
}
